// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc-block[data-v-e2d76f58] {\n  margin-bottom: 20px;\n}\n.go-btn[data-v-e2d76f58] {\n  width: 84px;\n  height: 36px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #0084ff;\n  color: #fff;\n  border-radius: 4px;\n  margin: 20px 0;\n}", ""]);
// Exports
module.exports = exports;
